module.exports = __webpack_public_path__ + "static/media/popular_learning_topics_4.b616a00f.png";